import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const getTextProprieties = (fontSize: string) => ({
  font: `700 ${fontSize}/21px Manrope`,
});

export const Wrapper = styled(Grid)(() => ({
  border: "1px solid #e4e7ec",
  borderRadius: 8,
  minHeight: 321,
}));

export const Header = styled(Grid)(() => ({
  marginBottom: "0.875rem",
  padding: "0.75rem 0 0 0.75rem",
}));

interface TitleProps {
  color?: string;
}
export const Title = styled(Grid)(({ color }: TitleProps) => ({
  ...getTextProprieties("1em"),
  marginBottom: 2,
  "& span": {
    color: color ?? "#308cdb",
  },
}));

export const SubTitle = styled(Grid)(() => ({
  ...getTextProprieties("0.875em"),
  color: "#98a3b3",
  flexWrap: "nowrap",
}));

export const Columns = styled(Grid)(() => ({
  backgroundColor: "#f9fafb",
  boxShadow: "0 2px 6px rgba(249, 250, 251, 0.12)",
  height: 32,
  alignItems: "center",
}));

interface ColumnTitleProp {
  width: string;
}
export const ColumnTitle = styled(Grid)(({ width }: ColumnTitleProp) => ({
  font: "700 15px/21px Manrope",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "0.75rem",
  width,
}));

export const Content = styled(Grid)(() => ({
  height: 208,
  display: "block",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: 4,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#93a9bd",
    borderRadius: 2,
  },
}));

export const ContentRow = styled(Grid)(({ width }: ColumnTitleProp) => ({
  display: "flex",
  paddingLeft: "1rem",
  height: 44,
  alignItems: "center",
  font: "400 14px/16px Manrope",
  color: "#667085",
  width,
}));

export const Footer = styled(Grid)(() => ({
  boxShadow: "0px -2px 6px rgba(70, 88, 105, 0.12)",
  height: 42,
  alignItems: "center",
}));
